const listProductExhibition = (theme) => ({
    reOrderActionsWrapper: {
        textAlign: 'right',
        marginTop: '20px',
    },
    reOrderCancelBtn: {
        marginRight: '15px',
    },
    reOrderApplyBtn: {},
});

export default listProductExhibition;
